import baseAPI from "../api/baseApi";
import { authHeader, authHeaderWithImage } from "../helpers/authHeader";

const getDashboard = async (data) => {
  try {
    const formdata = new FormData();

    // console.log("DATATA", data);

    formdata.append("subscrption_id", data);

    const res = await baseAPI.post(`/merchant-dashboard`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getBranchDashboard = async (data) => {
  try {
    const formdata = new FormData();

    // formdata.append("subscrption_id", data?.subscrption_id);

    const res = await baseAPI.post(`/branch-dashboard`, formdata, {
      headers: authHeader(),
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const DashboardService = {
  getDashboard,
  getBranchDashboard,
};

export default DashboardService;
